module.exports = __webpack_public_path__ + "img/upwork-review-large-3.01a18ca8.jpg";